"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTag = exports.deleteTag = exports.getAllTags = exports.retrieveTag = exports.createTag = void 0;
const http_1 = require("../utils/http");
const endpoint = 'tags';
/**
 * Create new tag on the Bee node
 *
 * @param url Bee tag URL
 */
async function createTag(requestOptions) {
    const response = await (0, http_1.http)(requestOptions, {
        method: 'post',
        url: endpoint,
        responseType: 'json',
    });
    return response.data;
}
exports.createTag = createTag;
/**
 * Retrieve tag information from Bee node
 *
 * @param url Bee tag URL
 * @param uid UID of tag to be retrieved
 */
async function retrieveTag(requestOptions, uid) {
    const response = await (0, http_1.http)(requestOptions, {
        url: `${endpoint}/${uid}`,
        responseType: 'json',
    });
    return response.data;
}
exports.retrieveTag = retrieveTag;
/**
 * Get limited listing of all tags.
 *
 * @param url
 * @param offset
 * @param limit
 */
async function getAllTags(requestOptions, offset, limit) {
    const response = await (0, http_1.http)(requestOptions, {
        url: endpoint,
        params: { offset, limit },
        responseType: 'json',
    });
    return response.data.tags;
}
exports.getAllTags = getAllTags;
/**
 * Removes tag from the Bee node.
 * @param url
 * @param uid
 */
async function deleteTag(requestOptions, uid) {
    await (0, http_1.http)(requestOptions, {
        method: 'delete',
        url: `${endpoint}/${uid}`,
    });
}
exports.deleteTag = deleteTag;
/**
 * Updates tag
 * @param url
 * @param uid
 * @param reference
 */
async function updateTag(requestOptions, uid, reference) {
    await (0, http_1.http)(requestOptions, {
        method: 'patch',
        url: `${endpoint}/${uid}`,
        data: {
            reference,
        },
    });
}
exports.updateTag = updateTag;
